import * as yup from 'yup';
import { ProfileTypes, TargetViewers } from '../../constants/profileType.constant';

const schema = yup.object().shape({
  postAs: yup.string().oneOf([ProfileTypes.Individual, ProfileTypes.Organization]).required(),
  targetViewers: yup.string().oneOf([TargetViewers.All, TargetViewers.SelectedOrg, TargetViewers.MyOrg]).required(),
  targetOrgs: yup.array().of(yup.number()).when(['targetViewers'], (targetViewers, schemaRef) => {
    if (targetViewers === TargetViewers.SelectedOrg) {
      return schemaRef
        .required('Please select at least one organization')
        .min(1, 'Please select an organization');
    }
    return schemaRef.nullable().notRequired();
  }),
});

export default schema;